export const isEqualStringNoSensitive = (str1: string, str2: string): boolean => {
  return (str1
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase() === str2
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase());
};
